module.exports = __webpack_public_path__ + "assets/img/tousu.7071c49e.svg";